import photoCatalog from 'virtual:narrative-photo-catalog';
import type { ArchiveAct, PhotoRecord } from '../types';

export const photoByKey = new Map(
  (photoCatalog as PhotoRecord[])
    .filter((photo) => photo.st === 'publishable')
    .map((photo) => [photo.k, photo]),
);

export function publicPhotoPath(source: string): string {
  return `./${source.replace(/^assets\//, '')}`;
}

function renderArchiveImage(photo: PhotoRecord, actIndex: string, index: number): HTMLElement {
  const variant = photo.v.find(({ width }) => width >= 960) ?? photo.v.at(-1);
  const figure = document.createElement('figure');
  const isLandscape = variant ? variant.width > variant.height : false;
  figure.className = `archive-mosaic__item ep-photo ep-photo--mosaic ep-photo--mosaic-${index} ${isLandscape ? 'is-landscape' : 'is-portrait'}`;
  if (index === 0) figure.classList.add('is-lead');
  figure.dataset.photoKey = photo.k;
  figure.dataset.status = photo.st;
  if (!variant) return figure;

  const image = document.createElement('img');
  image.src = publicPhotoPath(variant.src);
  image.srcset = photo.v.map((item) => `${publicPhotoPath(item.src)} ${item.width}w`).join(', ');
  image.sizes = index === 0 ? '(max-width: 800px) 100vw, 42vw' : '(max-width: 800px) 50vw, 24vw';
  image.width = variant.width;
  image.height = variant.height;
  image.alt = photo.t;
  image.loading = 'lazy';
  image.decoding = 'async';

  const caption = document.createElement('figcaption');
  const reference = document.createElement('span');
  reference.textContent = photo.t;
  caption.append(reference);
  figure.append(image, caption);
  return figure;
}

export function renderArchiveAct(act: ArchiveAct, total: number): HTMLElement {
  const section = document.createElement('section');
  section.id = act.id;
  section.className = 'archive-act beat-section ep-photo-mosaic';
  section.dataset.beatId = act.beatId;
  section.dataset.chapterId = act.afterChapterId;
  section.dataset.visualMode = 'archive';
  section.dataset.archiveIndex = act.index;
  section.dataset.archiveTotal = String(total).padStart(2, '0');

  const header = document.createElement('header');
  header.className = 'archive-act__header';
  const index = document.createElement('p');
  index.className = 'archive-act__index ep-eyebrow';
  index.textContent = `Архив ${act.index} / ${String(total).padStart(2, '0')}`;
  const copy = document.createElement('div');
  copy.className = 'archive-act__copy';
  const title = document.createElement('h3');
  title.textContent = 'Фотоархив';
  const source = document.createElement('p');
  source.className = 'archive-act__source';
  source.textContent = act.sourceLabel;
  copy.append(title, source);
  header.append(index, copy);

  const mosaic = document.createElement('div');
  mosaic.className = 'archive-mosaic ep-photo-mosaic__grid';
  const photos = act.photoKeys.flatMap((key) => {
    const photo = photoByKey.get(key);
    return photo ? [photo] : [];
  });
  if (photos.length === 1) section.classList.add('is-single');
  for (const [photoIndex, photo] of photos.entries()) {
    mosaic.append(renderArchiveImage(photo, act.index, photoIndex));
  }

  section.append(header, mosaic);
  return section;
}
